export default class WindowUtils {
    static openNewTab(url: string) {
        window.open(url);
    }

    static openNewWindow(url: string, params: string) {
        window.open(url, '_blank', params);
    }

    static openViadialog(token: string) {
        if (token) {
            WindowUtils.openNewWindow(
                `https://banner.viadialog.com/banner.php?tk=${token}`,
                'toolbar=0,location=0,menubar=0,height=700,width=300',
            );
        }
    }
}
